var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('mj-navbar'),_c('router-view',{staticClass:"section"}),_c('mj-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }